import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-info-dialog',
  imports: [],
  templateUrl: './info-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoDialogComponent {
  readonly isOpen = input(false);
  readonly title = input('Informazione');
  readonly message = input('');
  readonly buttonLabel = input('Chiudi');

  readonly closed = output<void>();
}
